import { useEffect, useState } from 'react';

// เก็บ `beforeinstallprompt` ไว้ระดับ module — event นี้ยิงครั้งเดียวตอนโหลดหน้า ถ้า listener อยู่ใน
// component ที่ mount ทีหลังจะพลาด event ไป (ลงทะเบียนตอน import ไฟล์นี้ ซึ่ง index.js โหลดตั้งแต่เริ่ม)
let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

export const isStandalone = () =>
  Boolean(window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone);

export async function promptInstall() {
  if (!deferredPrompt) return;
  const promptEvent = deferredPrompt;
  promptEvent.prompt();
  await promptEvent.userChoice;
  deferredPrompt = null;
  notify();
}

// canInstall = เบราว์เซอร์พร้อมให้กดติดตั้งได้เลย (Chromium เท่านั้น)
export function usePwaInstall() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const fn = () => setTick((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return { canInstall: Boolean(deferredPrompt), install: promptInstall };
}
